/* eslint-disable no-console */
import {
  CaretUpOutlined,
  CaretDownOutlined,
  LoadingOutlined
} from '@ant-design/icons';
import {useAuth0} from '@auth0/auth0-react';
import {Menu as MenuAnt, MenuProps} from 'antd';
import React, {useEffect, useMemo, useState} from 'react';
import {Link, useLocation, useNavigate} from 'react-router-dom';

import {ReactComponent as ActivityLog} from '../../assets/AcitivityLog.svg';
import {ReactComponent as ReportStudio} from '../../assets/icons/File_Report.svg';
import {ReactComponent as Logout} from '../../assets/icons/Log_Out.svg';
import {ReactComponent as PlatformEducationIcon} from '../../assets/icons/PlatformEducationIcon.svg';
import {ReactComponent as Setting} from '../../assets/icons/Settings_Future.svg';
import {PermissionEnum} from '../../constants/permissionsEnum';
import {Routes, allRoutes, subRoutes} from '../../constants/Routes';
import TranslatedText from '../../libraries/I18N/TranslatedText';
import loginActivityDetail from '../../services/modules/User/loginActivityDetail';
import useCompanyStore from '../../store/companyStore/companyDetailsStore'; // accessModule
import {removeSlash} from '../../utils/removeSlash';
// import {shouldBlockModuleAccess} from '../../utils/SubscriptionHelper';

import {checkIfHasPermissions, sideNavMapping} from './Utils/commonFunctions';
import CurrentPlanInfoComp from './Utils/CurrentPlanInfoComp';

const BottomMenu: React.FC<{
  setOpenKeys: React.Dispatch<React.SetStateAction<string[]>>;
  openKeys: string[];
  product: string;
  menuCollapsed: boolean;
}> = ({setOpenKeys, openKeys, product, menuCollapsed}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLogoutCalled, setIsLogoutCalled] = useState(false);
  const {logout, user} = useAuth0();
  const activePlan = useCompanyStore((s) => s.subscription?.planType);

  useEffect(() => {
    if (isLogoutCalled) {
      loginActivityDetail({isLogin: false, user})
        .then(() => {
          logout({logoutParams: {returnTo: window.location.origin}})
            .then(async () => {})
            .catch(() => {});
          localStorage.removeItem('isLogged');
          localStorage.removeItem('token');
          localStorage.removeItem('product');
        })
        .catch(() => {});
    }
  }, [isLogoutCalled]);

  const sideNavbottom = [
    {
      name: 'menu_item_platform_education',
      key: removeSlash(Routes.PLATFORM_EDUCATION),
      icon: (
        <Link to={Routes.PLATFORM_EDUCATION}>
          <PlatformEducationIcon className="icon" />
        </Link>
      ),
      label: <TranslatedText translationKey="Learning Hub" />,
      // hidden: shouldBlockModuleAccess(accessModule.Platform_Education),
      hidden: false,
      isNotProduct: true,
      route: Routes.PLATFORM_EDUCATION
    },
    {
      name: 'menu_item_report_studio',
      key: removeSlash(Routes.REPORT_STUDIO),
      icon: (
        <Link to={Routes.REPORT_STUDIO}>
          <ReportStudio className="icon" />
        </Link>
      ),
      label: <TranslatedText translationKey="Report Studio" />,
      hidden: false, // Temporarily set to false for testing
      isNotProduct: true,
      route: Routes.REPORT_STUDIO
    },
    {
      name: 'menu_item_activity_log',
      key: removeSlash(Routes.ACTIVITY_LOG),
      icon: (
        <Link to={Routes.ACTIVITY_LOG}>
          <ActivityLog className="icon" />
        </Link>
      ),
      label: <TranslatedText translationKey="Activity Log" />,
      hidden: !checkIfHasPermissions(PermissionEnum.ActivityLog),
      isNotProduct: true,
      route: Routes.ACTIVITY_LOG
    },
    {
      key: removeSlash(Routes.SETTING),
      icon: <Setting className="icon" />,
      label: <TranslatedText translationKey="Settings" />,
      route: Routes.SETTING,
      hidden: true,
      children: [
        {
          key: removeSlash(subRoutes.unitPreference),
          label: <TranslatedText translationKey="UNIT_PREFERENCES" />,
          onClick: () => {
            navigate(`${allRoutes.setting.unitPreference}`);
          },
          hidden: true
        },
        {
          key: removeSlash(subRoutes.userManager),
          label: <TranslatedText translationKey="USER_MANAGER" />,
          onClick: () => {
            navigate(`${allRoutes.setting.userManager}`);
          },
          hidden: true
        },
        {
          key: removeSlash(subRoutes.setup),
          label: <TranslatedText translationKey="SETUP" />,
          onClick: () => {
            navigate(`${allRoutes.setting.setup}`);
          },
          hidden: true
        }
      ]
    },
    {
      key: 'logout',
      icon: isLogoutCalled ? (
        <LoadingOutlined className="icon" style={{fontSize: '200%'}} spin />
      ) : (
        <Logout className="icon" style={{fontSize: '200%', color: 'black'}} />
      ),
      label: isLogoutCalled ? (
        'Signing out...'
      ) : (
        <TranslatedText translationKey="Sign Out" />
      ),
      onClick: () => {
        if (!isLogoutCalled) {
          setIsLogoutCalled(true);
        }
      },
      route: 'logout',
      isNotProduct: true,
      disabled: isLogoutCalled
    }
  ];

  // const handleRedirect = ({key}: {key: string}) => {
  //   const menu = sideNavbottom.find((item) => item.key === key) ?? {
  //     route: null,
  //     onClick: null
  //   };
  //   if (menu.route !== 'logout' && menu.route !== null) {
  //     navigate(menu.route);
  //   } else {
  //     if (menu.onClick) {
  //       menu.onClick();
  //     }
  //   }
  // };

  const onOpenChange: MenuProps['onOpenChange'] = (keys) => {
    const lastKey = keys[keys.length - 1];
    keys.shift();

    setOpenKeys(keys.length > 0 ? keys : [lastKey]);
  };

  const handleSelected = (): string[] => {
    const locationPath = location.pathname.split('/');

    const parent = sideNavbottom?.find((item) => {
      return item.route === `/${locationPath[1]}`;
    });

    const sub = parent?.children?.find((item) => {
      return item.key === locationPath[2];
    });

    return [parent?.key ?? '', sub?.key ?? ''];
  };

  const hideNavs = useMemo(() => {
    return sideNavMapping(sideNavbottom, product);
  }, [product, isLogoutCalled]);

  return (
    <div className="bottomMenu">
      {!menuCollapsed && <CurrentPlanInfoComp activePlan={activePlan} />}
      <span className="menuTopTitle">General</span>
      <MenuAnt
        mode="inline"
        className="menu"
        items={hideNavs}
        openKeys={openKeys}
        onOpenChange={onOpenChange}
        // onClick={handleRedirect}
        expandIcon={({isOpen}) => {
          return isOpen ? <CaretUpOutlined /> : <CaretDownOutlined />;
        }}
        defaultSelectedKeys={[
          location.pathname.split('/')[1],
          location.pathname.split('/')[2]
        ]}
        selectedKeys={handleSelected()}
        triggerSubMenuAction="click"
      />
    </div>
  );
};

export default BottomMenu;
